import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/logo-dashboard-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_MoneyAndUserInfo = _resolveComponent("MoneyAndUserInfo")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_header, { class: "main-layout-header" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, { class: "toolbar" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
              class: "logo"
            }, _hoisted_2),
            (_ctx.$q.screen.width < 1280)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.user?.data?.isApproved)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        round: "",
                        icon: _ctx.menuVisible ? 'close' : 'menu',
                        onClick: _ctx.toggleMenu
                      }, null, 8, ["icon", "onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_MoneyAndUserInfo, {
                  key: 1,
                  image: _ctx.profileImagePath,
                  approve: _ctx.approveBalance,
                  hold: _ctx.holdBalance,
                  profit: _ctx.approveBalanceBuying,
                  affiliate: _ctx.affiliate
                }, null, 8, ["image", "approve", "hold", "profit", "affiliate"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_drawer, {
      style: {"background-color":"#131212"},
      modelValue: _ctx.menuVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.menuVisible) = $event)),
      class: "custom-drawer",
      overlay: "",
      behavior: "desktop",
      width: _ctx.$q.screen.width
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MoneyAndUserInfo, {
          className: "hide-on-desktop",
          image: _ctx.profileImagePath,
          approve: _ctx.approveBalance,
          hold: _ctx.holdBalance,
          profit: _ctx.approveBalanceBuying,
          affiliate: _ctx.affiliate
        }, null, 8, ["image", "approve", "hold", "profit", "affiliate"]),
        (_ctx.isApproved)
          ? (_openBlock(), _createBlock(_component_Navigation, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ], 64))
}